<template>
  <div class="line"></div>
  <div class="disclaimer">
    <div class="content">
      <div class="left">
        <img class="icon" src="@/assets/images/icons/tips.svg" alt="" />
        <div class="title">{{ $t('product.disclaimer1') }}</div>
      </div>
      <div class="right">
        {{ $t('product.disclaimer') }}
      </div>
    </div>
    <div class="agree-btn">
      <slot></slot>
    </div>

  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.line {
  background-color: var(--line-light-gray-color);
  height: 1px;
  margin-bottom: 20px;
  margin-top: 20px;
}

.disclaimer {
  border-radius: 8px;
  border: 1px solid var(--primary-color);
  padding: 12px 18px;
  margin-bottom: 20px;

  .content {
    display: flex;
  }

  .left {
    margin-right: 15px;
    width: 150px;
  }

  .right {
    font-size: 12px;
    font-weight: normal;
    line-height: normal;
    color: var(--primary-color);
  }

  .icon {
    width: 15px;
    height: 15px;
  }

  .title {
    font-size: 14px;
    font-weight: 600;
    line-height: normal;
    margin-top: 10px;
    color: var(--primary-color);
  }

  .agree-btn {
    display: flex;
    margin-top: 10px;
    // justify-content: center;
  }
}
</style>
